import axios from 'axios';
import {v4 as uuidv4} from 'uuid';

export class Integration {
  baseUrl = '';
  securityToken = '';

  init(host: string, securityToken: string): void {
    this.baseUrl = `${host}/app/`;
    this.securityToken = securityToken;
  }

  async startCalculationOnWeb(importFile: Blob): Promise<string> {
    const formData = new FormData();
    formData.append('importFile', importFile, 'data.xlsx');
    formData.append('fileToken', uuidv4());
    formData.append('securityToken', this.securityToken);

    const url = new URL('api/startCalculationOnWeb', this.baseUrl);

    const {data: importFilePath} = await axios.post(url.toString(), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return importFilePath;
  }

  continueCalculationOnWeb(importFilePath: string): void {
    const url = new URL('sec/importMapper', this.baseUrl);

    url.searchParams.append('applicationId', 'IFC');
    url.searchParams.append('importMapperId', 'IFCFromSimpleBIM');
    url.searchParams.append('importFilePath', importFilePath);

    window.open(url, '_blank');
  }
}
